module.exports = __webpack_public_path__ + "static/media/state3.png";